import { Splide, SplideSlide } from '@splidejs/react-splide'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { useSponsorTypesContext } from '../context/sponsor-types/SponsorTypeProvider'

const options = {
  direction: 'rtl',
  perPage: 1,
  perMove: 1,
  autoplay: true,
  loop: true,
  interval: 2500,
  arrows: false,
  pagination: false,
  rewind: true,
  pauseOnFocus: true,
  pauseOnHover: true,
  speed: 1000,
  gap: 2,
  drag: false,
  keyboard: false,
  swipe: false,
}

// export default function FloatingSliderDiamondSponsors() {
//   const { t } = useTranslation()
//   const { lng } = useParams()
//   const { sponsorTypesState } = useSponsorTypesContext()
//   if (!sponsorTypesState.isLoading && sponsorTypesState.types.diamond?.have_sponsors) {
//     return (
//       <div className="fixed right-0 top-1/2 z-10 -translate-y-1/2 transform px-4">
//         <div className="w-[64px]">
//           <div className="mb-2 border-2 border-white bg-info px-2 py-1 text-center text-xs text-white">{t('SPONSORS')}</div>
//           <Splide
//             aria-label={`Sponsors Logos Slider`}
//             options={options}
//           >
//             {sponsorTypesState.types.diamond?.sponsors.map((sponsor) => (
//               <SplideSlide
//                 className={`flex items-center justify-center`}
//                 key={sponsor.id}
//                 title={sponsor[`name_${lng}`]}
//               >
//                 <Link
//                   to={`/${lng}/sponsors/${sponsor.slug}`}
//                   className="flex !h-[64px] !w-[64px] overflow-hidden border-2 border-muted-300 bg-light p-2"
//                 >
//                   <img
//                     className="h-full w-full object-contain"
//                     src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.logo}`}
//                     alt={sponsor[`name_${lng}`]}
//                   />
//                 </Link>
//               </SplideSlide>
//             ))}
//           </Splide>
//         </div>
//       </div>
//     )
//   }
// }






export default function FloatingSliderDiamondSponsors() {
  const { t } = useTranslation()
  const { lng } = useParams()
  const { sponsorTypesState } = useSponsorTypesContext()

  const diamond = sponsorTypesState?.types?.diamond

  if (sponsorTypesState.isLoading || !diamond?.have_sponsors) return null

  return (
    <div className="fixed right-0 top-1/2 z-10 -translate-y-1/2 transform px-4">
      <div className="w-[64px]">
        <div className="mb-2 border-2 border-white bg-info px-2 py-1 text-center text-xs text-white">
          {t('SPONSORS')}
        </div>
        <Splide
          aria-label={`Sponsors Logos Slider`}
          options={options}
        >
          {diamond.sponsors.map((sponsor) => (
            <SplideSlide
              className={`flex items-center justify-center`}
              key={sponsor.id}
              title={sponsor[`name_${lng}`]}
            >
              <Link
                to={`/${lng}/sponsors/${sponsor.slug}`}
                className="flex !h-[64px] !w-[64px] overflow-hidden border-2 border-muted-300 bg-light p-2"
              >
                <img
                  className="h-full w-full object-contain"
                  src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.logo}`}
                  alt={sponsor[`name_${lng}`]}
                />
              </Link>
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </div>
  )
}